(() => {
  const parseData = (root, selector) => {
    try { return JSON.parse(root.querySelector(selector)?.textContent || '[]'); }
    catch (_error) { return []; }
  };
  // Demo money(): whole amounts drop the .00 ($37), other amounts keep cents ($1.85).
  const money = (cents, currency = 'USD') => new Intl.NumberFormat('en-US', { style: 'currency', currency, maximumFractionDigits: 2 }).format((Number(cents) || 0) / 100).replace(/\.00$/, '');
  const money2 = (cents, currency = 'USD') => new Intl.NumberFormat('en-US', { style: 'currency', currency, minimumFractionDigits: 2, maximumFractionDigits: 2 }).format((Number(cents) || 0) / 100);
  // Demo catalogue order (PRODUCTS): ties in price keep this order, and the compare chips follow it.
  const DEMO_ORDER = ['aoarashi', 'isuzu', 'chigi', 'yugen', 'wako', 'kinrin', 'unkaku', 'wakatake', 'samidori', 'matsukaze', 'yomono', 'nishi', 'miyo', 'ishiwako', 'nishiki', 'aya', 'biwa', 'hoho'];
  const demoRank = (tea) => { const index = DEMO_ORDER.indexOf(tea); return index < 0 ? DEMO_ORDER.length : index; };
  const byDemoOrder = (list) => list.slice().sort((a, b) => demoRank(a.tea) - demoRank(b.tea));
  const escapeHtml = (value) => String(value || '').replace(/[&<>'"]/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[character]));

  const initFinder = (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const products = byDemoOrder(parseData(root, '[data-finder-products]'));
    const panels = [...root.querySelectorAll('[data-finder-panel]')];
    const progress = [...root.querySelectorAll('[data-finder-progress] i')];
    const answers = {};
    let step = 0;

    const show = () => {
      panels.forEach((panel, index) => { panel.hidden = index !== step; });
      progress.forEach((bar, index) => bar.classList.toggle('is-active', index <= Math.min(step, 2)));
    };
    // Demo pageFinder logic: in-stock pool for the chosen use, budget band (kept only when it matches),
    // sorted by price; "sweet" reverses, "balanced" rotates from the middle. Top pick plus up to two alternates.
    const fitting = () => {
      let pool = products.filter((product) => product.available && Array.isArray(product.uses) && product.uses.includes(answers.use));
      const inBudget = pool.filter((product) => answers.budget === 'low' ? product.price < 3500 : answers.budget === 'mid' ? product.price >= 3500 && product.price <= 5000 : product.price > 5000);
      if (inBudget.length) pool = inBudget;
      pool.sort((a, b) => a.price - b.price);
      if (answers.taste === 'sweet') pool.reverse();
      if (answers.taste === 'balanced' && pool.length > 2) pool = pool.slice(Math.floor(pool.length / 2)).concat(pool.slice(0, Math.floor(pool.length / 2)));
      return { top: pool[0] || null, alts: pool.slice(1, 3), inBudget: inBudget.length > 0 };
    };
    const renderResult = () => {
      const { top: product, alts, inBudget } = fitting();
      const result = root.querySelector('[data-finder-result]');
      if (!product) {
        result.innerHTML = '<p>No tin in stock matches. <button class="saintcha-finder__link ghost" type="button" data-finder-reset>Start over</button></p>';
        return;
      }
      const useText = { latte: 'lattes', usucha: 'whisked usucha', koicha: 'koicha', hojicha: 'a roasted cup' }[answers.use];
      const tasteText = { bold: 'a brighter, bolder cup', balanced: 'a balanced cup', sweet: 'a sweeter, deeper cup' }[answers.taste];
      const view = product.kind === 'bag' ? `View ${escapeHtml(product.size)}` : 'View the tin';
      const altsHtml = alts.length ? `<div class="saintcha-finder__alts"><span class="eyebrow">Also worth a look</span><div class="saintcha-finder__alts-grid">${alts.map((alt) => `<a class="saintcha-finder__alt" href="${escapeHtml(alt.url)}"><span class="saintcha-finder__alt-media"><img src="${escapeHtml(alt.image)}" alt="${escapeHtml(alt.fullTitle || alt.title)}" loading="lazy"></span><span><span class="eyebrow">${escapeHtml(alt.house)}</span><strong class="serif">${escapeHtml(alt.title)}</strong><span>${money(alt.price, root.dataset.currency)}</span></span></a>`).join('')}</div></div>` : '';
      result.innerHTML = `<div class="saintcha-finder__result-main"><div class="saintcha-finder__result-media"><img class="kb" src="${escapeHtml(product.image)}" alt=""></div><div class="saintcha-finder__result-copy"><span class="eyebrow">Your fitting</span><span class="eyebrow">${escapeHtml(product.house)}</span><h2 class="serif">${escapeHtml(product.title)}</h2><strong>${money(product.price, root.dataset.currency)} · ${escapeHtml(product.size)}</strong><p>You drink it as ${escapeHtml(useText)} and prefer ${escapeHtml(tasteText)}. ${escapeHtml(product.title)} is our pick${inBudget ? ' in your price range' : '; nothing matched that budget exactly, so this is the closest'}.</p><div class="saintcha-finder__actions"><button class="button btn" type="button" data-finder-add data-id="${product.variant}" data-max="${Number.isFinite(Number(product.max)) ? Number(product.max) : ''}">Add to bag</button><a class="button button--secondary ghost" href="${escapeHtml(product.url)}">${view}</a><button class="button button--secondary ghost" type="button" data-finder-reset>Start over</button></div></div></div>${altsHtml}`;
    };

    root.addEventListener('click', async (event) => {
      const pick = event.target.closest('[data-finder-pick]');
      const back = event.target.closest('[data-finder-back]');
      const reset = event.target.closest('[data-finder-reset]');
      const add = event.target.closest('[data-finder-add]');
      if (pick) {
        answers[pick.dataset.key] = pick.dataset.value;
        step = Math.min(3, step + 1);
        if (step === 3) renderResult();
        show();
      }
      if (back) { step = Math.max(0, step - 1); show(); }
      if (reset) { Object.keys(answers).forEach((key) => delete answers[key]); step = 0; show(); }
      if (add) {
        add.disabled = true;
        const rootPath = window.Shopify?.routes?.root || '/';
        const bag = window.SaintchaBag;
        if (bag) {
          // Cumulative limit: the Liquid limit minus what is already in the bag.
          const cap = await bag.capQuantity(add.dataset.id, 1, add.dataset.max);
          bag.notice(add.parentElement, '');
          if (cap.allowed < 1) { add.disabled = false; bag.notice(add.parentElement, bag.LIMIT_MESSAGE); bag.showFull(); return; }
        }
        const response = await fetch(`${rootPath}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(add.dataset.id), quantity: 1 }] }) });
        if (response.ok && window.SaintchaBag) {
          add.disabled = false;
          const finderImage = root.querySelector('.saintcha-finder__result-media img');
          window.SaintchaBag.added({ source: add, image: finderImage ? finderImage.src : '' });
        } else if (response.ok) window.location.assign(`${rootPath}cart`);
        else add.disabled = false;
      }
    });
    show();
  };

  const initCompare = (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const products = byDemoOrder(parseData(root, '[data-compare-products]'));
    const byTea = (tea) => products.find((product) => product.tea === tea);
    // Demo default columns: Aoarashi, Isuzu, Chigi no Shiro.
    const selected = ['aoarashi', 'isuzu', 'chigi'].filter((tea) => byTea(tea));
    const count = root.querySelector('[data-compare-count]');
    const picker = root.querySelector('[data-compare-picker]');
    const head = root.querySelector('[data-compare-head]');
    const body = root.querySelector('[data-compare-body]');
    const USE = { latte: 'Latte', usucha: 'Usucha', koicha: 'Koicha', culinary: 'Culinary', hojicha: 'Hojicha' };
    const grams = (p) => Number.parseFloat(p.size) || 0;
    const rows = [
      ['Price', (p) => money(p.price, root.dataset.currency)],
      ['Size', (p) => `${grams(p)}g`],
      ['Price per 2g bowl', (p) => grams(p) ? money2(p.price / (grams(p) / 2), root.dataset.currency) : ''],
      ['Best for', (p) => (p.uses || []).map((use) => USE[use] || use).join(', ')],
      ['Koicha grade', (p) => (p.uses || []).includes('koicha') ? 'Yes' : 'No'],
      ['Character', (p) => p.character || ''],
      ['Origin', (p) => p.origin || ''],
      // Store rule: $2 off each tin in a 2 to 4 piece set (Shopify automatic discount).
      ['In a set', (p) => `${money(Math.max(0, p.price - 200), root.dataset.currency)} each`]
    ];
    // Demo compare chips: the house short name first, except for Marukyu Koyamaen ("Yamamasa Samidori", "Aoarashi").
    const chipLabel = (product) => `${product.house && product.house !== 'Marukyu Koyamaen' ? `${String(product.house).split(' ')[0]} ` : ''}${product.title}`;
    picker.innerHTML = products.map((product) => `<button class="chip" type="button" data-compare-pick data-tea="${escapeHtml(product.tea)}">${escapeHtml(chipLabel(product))}</button>`).join('');
    const render = () => {
      root.querySelectorAll('[data-compare-pick]').forEach((button) => { const on = selected.includes(button.dataset.tea); button.classList.toggle('is-active', on); if (!button.closest('.saintcha-compare__actions')) button.classList.toggle('on', on); });
      count.textContent = selected.length;
      const columns = [0, 1, 2].map((index) => (selected[index] && byTea(selected[index])) || null);
      head.innerHTML = `<th></th>${columns.map((product) => `<th>${product ? `<div class="saintcha-compare__product"><div class="saintcha-compare__media"><img src="${escapeHtml(product.image)}" alt="${escapeHtml(product.fullTitle || product.title)}"></div><span class="small soft">${escapeHtml(product.house)}</span><h2 class="h3"><a href="${escapeHtml(product.url)}">${escapeHtml(product.title)}</a></h2><div class="saintcha-compare__actions">${product.available && Number(product.max) !== 0 ? `<button class="button btn" type="button" data-compare-add data-id="${product.variant}" data-max="${Number.isFinite(Number(product.max)) ? Number(product.max) : ''}">Add</button>` : '<button class="button btn" type="button" disabled>Sold out</button>'}<button class="button button--secondary chip" type="button" data-compare-pick data-tea="${escapeHtml(product.tea)}">Remove</button></div></div>` : '<span>Pick a tin above</span>'}</th>`).join('')}`;
      body.innerHTML = rows.map(([label, format]) => `<tr><td>${label}</td>${columns.map((product) => `<td>${product ? escapeHtml(format(product)) : ''}</td>`).join('')}</tr>`).join('');
    };
    root.addEventListener('click', async (event) => {
      const add = event.target.closest('[data-compare-add]');
      if (add) {
        add.disabled = true;
        const rootPath = window.Shopify?.routes?.root || '/';
        const bag = window.SaintchaBag;
        const actions = add.parentElement;
        if (bag) {
          // Same cumulative limit as every other theme add.
          const cap = await bag.capQuantity(add.dataset.id, 1, add.dataset.max);
          bag.notice(actions, '');
          if (cap.allowed < 1) { add.disabled = false; bag.notice(actions, bag.LIMIT_MESSAGE); bag.showFull(); return; }
        }
        const response = await fetch(`${rootPath}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(add.dataset.id), quantity: 1 }] }) });
        add.disabled = false;
        if (response.ok && bag) {
          const image = add.closest('.saintcha-compare__product')?.querySelector('img');
          bag.added({ source: add, image: image ? image.src : '' });
        } else if (response.ok) window.location.assign(`${rootPath}cart`);
        else if (bag) {
          const error = await response.json().catch(() => ({}));
          bag.notice(actions, typeof error.description === 'string' ? error.description : 'Could not add this item. Please try again.');
        }
        return;
      }
      const button = event.target.closest('[data-compare-pick]');
      if (!button) return;
      const tea = button.dataset.tea;
      const index = selected.indexOf(tea);
      if (index >= 0) selected.splice(index, 1);
      else if (selected.length < 3) selected.push(tea);
      render();
    });
    render();
  };

  const initFaq = (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    root.addEventListener('click', (event) => {
      const tab = event.target.closest('[data-faq-tab]');
      if (!tab) return;
      root.querySelectorAll('[data-faq-tab]').forEach((button) => { button.classList.toggle('is-active', button === tab); button.classList.toggle('on', button === tab); });
      root.querySelectorAll('[data-faq-group]').forEach((group) => { group.hidden = group.dataset.faqGroup !== tab.dataset.faqTab; });
    });
  };

  const init = () => {
    document.querySelectorAll('[data-finder]').forEach(initFinder);
    document.querySelectorAll('[data-compare]').forEach(initCompare);
    document.querySelectorAll('[data-faq]').forEach(initFaq);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
